import type { OverviewPayload } from './types';

export const ownerOverview: OverviewPayload = {
  meta: {
    exported_at: new Date().toISOString(),
    duration_ms: 1820,
    errors: [],
  },
  kpis: {
    sales_today_mxn: 184_350.42,
    ticket_count_today: 73,
    sales_yesterday_mxn: 162_117.0,
    ticket_count_yesterday: 68,
    gross_margin_pct_today: 28.4,
    ar_total_mxn: 1_204_889.15,
    ar_aging: [
      { label: '0-30', amount_mxn: 712_300.0 },
      { label: '31-60', amount_mxn: 298_589.15 },
      { label: '61-90', amount_mxn: 121_000.0 },
      { label: '90+', amount_mxn: 73_000.0 },
    ],
    inventory_cost_mxn: 8_412_900.0,
    low_stock_count: 41,
  },
  sales_today: {
    hours: Array.from({ length: 14 }, (_, i) => {
      const h = (i + 7).toString().padStart(2, '0');
      const today = Math.round((10000 + Math.sin(i / 2) * 4000 + Math.random() * 2000) * 100) / 100;
      const last = Math.round((9000 + Math.sin(i / 2) * 3500 + Math.random() * 2000) * 100) / 100;
      return { hour: h, today_mxn: today, last_week_mxn: last };
    }),
  },
  top_parts: [
    { line: 'AC',   part: 'A1234',  pdesc: 'BALATA DELANTERA NISSAN TSURU',     qty_sold: 38, revenue_mxn: 22_990 },
    { line: 'GTS',  part: 'GT-5501', pdesc: 'BUJIA IRIDIO DENSO',                qty_sold: 142, revenue_mxn: 19_880 },
    { line: 'MOB',  part: '15W40-19', pdesc: 'ACEITE MOBIL DELVAC 19L',          qty_sold: 12, revenue_mxn: 16_440 },
    { line: 'BOS',  part: 'F002',    pdesc: 'INYECTOR BOSCH F002',               qty_sold: 9,  revenue_mxn: 13_500 },
    { line: 'DEN',  part: 'DEN-882', pdesc: 'ALTERNADOR DENSO 882',              qty_sold: 4,  revenue_mxn: 12_800 },
    { line: 'AC',   part: 'A1010',  pdesc: 'DISCO DE FRENO VENTILADO',           qty_sold: 16, revenue_mxn: 11_200 },
    { line: 'NGK',  part: 'NGK-6',  pdesc: 'BUJIA NGK PLATINO',                  qty_sold: 88, revenue_mxn: 9_680 },
    { line: 'WIX',  part: 'WIX51515', pdesc: 'FILTRO ACEITE WIX 51515',          qty_sold: 53, revenue_mxn: 7_950 },
    { line: 'GAT',  part: 'B205',   pdesc: 'BANDA MICRO-V GATES B205',           qty_sold: 11, revenue_mxn: 6_490 },
    { line: 'ACD',  part: 'ACD-77', pdesc: 'PASTILLAS ACDELCO 77',               qty_sold: 14, revenue_mxn: 5_880 },
  ],
  top_customers: [
    { anum: '100201', name: 'TALLER MECÁNICO HERMANOS LÓPEZ',      revenue_mxn: 312_400, ticket_count: 87 },
    { anum: '100087', name: 'AUTOSERVICIO JUÁREZ',                  revenue_mxn: 244_120, ticket_count: 64 },
    { anum: '100455', name: 'TRANSPORTES NORTE S.A. DE C.V.',       revenue_mxn: 198_900, ticket_count: 22 },
    { anum: '100612', name: 'GARCÍA & HIJOS REFACCIONES',           revenue_mxn: 154_330, ticket_count: 41 },
    { anum: '100009', name: 'TALLER EL CHIVO',                      revenue_mxn: 132_700, ticket_count: 58 },
  ],
  low_stock: [
    { line: 'AC',  part: 'A1234',  pdesc: 'BALATA DELANTERA NISSAN TSURU', sid: 1, on_hand: 2,  min: 10, last_sold: '2026-05-07' },
    { line: 'BOS', part: 'F002',   pdesc: 'INYECTOR BOSCH F002',           sid: 1, on_hand: 0,  min: 4,  last_sold: '2026-05-06' },
    { line: 'DEN', part: 'DEN-882', pdesc: 'ALTERNADOR DENSO 882',         sid: 2, on_hand: 1,  min: 3,  last_sold: '2026-05-05' },
    { line: 'WIX', part: 'WIX51515', pdesc: 'FILTRO ACEITE WIX 51515',     sid: 1, on_hand: 6,  min: 25, last_sold: '2026-05-08' },
    { line: 'NGK', part: 'NGK-6',  pdesc: 'BUJIA NGK PLATINO',             sid: 3, on_hand: 11, min: 40, last_sold: '2026-05-07' },
  ],
  slow_movers: [
    { line: 'OBS', part: 'X-001', pdesc: 'CABLE DE BUJIA TSURU 90',        sid: 1, on_hand: 18, value_mxn: 7_200, days_since_last_sale: 142 },
    { line: 'OBS', part: 'X-117', pdesc: 'JUEGO EMPAQUES MOTOR VW SEDAN',  sid: 1, on_hand: 4,  value_mxn: 6_400, days_since_last_sale: 220 },
    { line: 'OBS', part: 'X-220', pdesc: 'BOMBA DE AGUA CHEVY 1.6',        sid: 2, on_hand: 9,  value_mxn: 5_310, days_since_last_sale: 95 },
  ],
  sales_by_store: [
    { sid: 1, store_name: 'Matriz Centro',    revenue_mxn: 96_400 },
    { sid: 2, store_name: 'Sucursal Norte',   revenue_mxn: 52_300 },
    { sid: 3, store_name: 'Sucursal Sur',     revenue_mxn: 35_650 },
  ],
  stores: [
    { sid: 1, name: 'Matriz Centro' },
    { sid: 2, name: 'Sucursal Norte' },
    { sid: 3, name: 'Sucursal Sur' },
  ],
};

/** Staff fixture: cost/margin stripped, sales_by_store empty, low_stock and
 *  slow_movers narrowed to sid=1 — mirrors what the Go backend will eventually
 *  enforce server-side. inventory_cost_mxn (cost-bearing) is null; the
 *  low-stock count survives so Staff still sees actionable shortage info. */
export const staffOverview: OverviewPayload = {
  ...ownerOverview,
  kpis: {
    ...ownerOverview.kpis,
    gross_margin_pct_today: null,
    inventory_cost_mxn: null,
  },
  low_stock: ownerOverview.low_stock.filter((r) => r.sid === 1),
  slow_movers: ownerOverview.slow_movers.filter((r) => r.sid === 1),
  sales_by_store: [],
};
